/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef, useEffect } from 'react'
import { useGLTF, useAnimations } from '@react-three/drei'

export function Cars({isPlaneFlying}, props) {
  const group = useRef()
  const { nodes, materials, animations } = useGLTF('/Cars.glb')
  const { actions, names } = useAnimations(animations, group)

  useEffect(() => {
    if(isPlaneFlying === true){
    actions[names].reset().fadeIn(2).play()
    actions[names].timeScale = 1.4


    }
    else
    {
      actions[names].stop()
    }
  }, [ actions, names, isPlaneFlying])

  return (
    <group ref={group} {...props} dispose={null} position={[-5,0,200]}>
      <group name="Scene">
        <mesh
          name="orangelambocar_geo"
          
          geometry={nodes.orangelambocar_geo.geometry}
          material={materials['rgp_tex.002']}
          position={[302.088, 1.874, -80.312]}
          rotation={[0, 0.041, 0]}
          scale={0.025}
        />
        <mesh
          name="whitecar_"
        
          geometry={nodes.whitecar_.geometry}
          material={materials['rgp_tex.002']}
          position={[300.696, 2.096, -70.243]}
          rotation={[0, -0.004, 0]}
          scale={0.025}
        />
        <mesh
          name="redcar_"
          
          geometry={nodes.redcar_.geometry}
          material={materials['rgp_tex.002']}
          position={[306.908, 1.956, -78.767]}
          rotation={[0, -0.031, 0]}
          scale={0.025}
        />
        <mesh
          name="lambocar_geo"
         
          geometry={nodes.lambocar_geo.geometry}
          material={materials['rgp_tex.002']}
          position={[294.482, 1.829, -69.848]}
          rotation={[0, -0.04, 0]}
          scale={0.025}
        />
      </group>
    </group>
  )
}

useGLTF.preload('/Cars.glb')
